import { useMutation } from "urql";

import { CreateRestructureDocument } from "../../../graphql/generated.ts";

export function useCreateRestructure() {
  return useMutation(CreateRestructureDocument);
}
